(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-image-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let swiper = new Swiper('.product_list', {
      slidesPerView: 4,
      spaceBetween: 15,
      autoHeight: false,
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        990: {
          slidesPerView: 'auto',
          spaceBetween: 15,
        },
        749: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        0: {
          slidesPerView: 2,
          spaceBetween: 10,
          // autoHeight: false
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection_hover_section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const titles = document.querySelectorAll('.all_collection_titles .single_coll_title');

    titles.forEach((title) => {
      title.addEventListener('mouseenter', function (e) {
        titles.forEach((el) => el.classList.remove('active'));

        this.classList.add('active');
        let collectionIndex = this.getAttribute('data-index');

        const collectionsContent = document.querySelectorAll(
          '.collections_product_list_and_desc .single_collection_content'
        );

        collectionsContent.forEach((el) => el.classList.remove('active'));

        collectionsContent.forEach((singleCol) => {
          singleCol.getAttribute('data-index') == collectionIndex ? singleCol.classList.add('active') : '';
        });

        const collectionsImages = document.querySelectorAll('.all_collections_images .single_collection_image');

        collectionsImages.forEach((el) => el.classList.remove('active'));

        collectionsImages.forEach((singleImageContainer) => {
          singleImageContainer.getAttribute('data-index') == collectionIndex
            ? singleImageContainer.classList.add('active')
            : '';
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspot-section"] && !Shopify.designMode) return;
  try {
    


  document.addEventListener("DOMContentLoaded", function() {

    document.querySelectorAll('.single_prod_hotspot').forEach(function(hotspot) {

      hotspot.addEventListener('mouseenter', handleHotspotInteraction);

      hotspot.addEventListener('click', function(e) {
        if (window.innerWidth <= 749) {
          handleHotspotInteraction.call(this, e);
        }
      });

    });

    function handleHotspotInteraction() {
      var hotspotVal = this.getAttribute('data-hotspot');
      var container = this.closest(".hotspot_banner_and_products");

      container.querySelectorAll('.single_prod_hotspot').forEach(function(h) {
        h.classList.remove('active');
      });

      container.querySelectorAll('.single_product_wrapper').forEach(function(wrapper) {
        wrapper.classList.remove('active');
      });

      this.classList.add('active');

      container.querySelectorAll('.single_product_wrapper').forEach(function(wrapper) {
        var wrapperHotspot = wrapper.getAttribute('data-hotspot');
        if (wrapperHotspot === hotspotVal) {
          wrapper.classList.add('active');
        }
      });
    }

 let swiper = new Swiper(".hotspot_main_slider", {
        slidesPerView: 1,
        spaceBetween: 15,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });

      
  });





    

  } catch(e) { console.error(e); }
})();
})();
